import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = { class: "banner-content text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_6 = { class: "contact-pages-area pt-120 mb-20" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row mb-50 d-flex justify-content-center" }
const _hoisted_11 = { class: "col-lg-6 mb-20" }
const _hoisted_12 = { class: "office-location" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "office-categoty" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "single-category d-lg-block d-none" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Main Office")
  ])
], -1)
const _hoisted_14 = { class: "row g-lg-12 gy-5" }
const _hoisted_15 = { class: "col-lg-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "single-category d-lg-none d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Main Office")
], -1)
const _hoisted_17 = { class: "single-location" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/images/icon/email-2.svg",
    alt: ""
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/images/icon/phone-5.svg",
    alt: ""
  })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "assets/images/icon/location.svg",
    alt: ""
  })
], -1)
const _hoisted_21 = { class: "row g-lg-4 gy-5" }
const _hoisted_22 = { class: "col-lg-6" }
const _hoisted_23 = { class: "contect-content" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h4", null, "Need Any Help? Contact Us", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, " We are committed to providing you with the support you need. Whether you have questions, need assistance, or want more information about our services, our team is here to help. ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "Feel free to use the contact details below to get in touch with us directly:", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-3" }, "Support Line:", -1)
const _hoisted_28 = { class: "title" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/footer-support-icon.svg",
  alt: ""
}, null, -1)
const _hoisted_30 = { href: "tel:{{ globalSettings._site_support_no }}" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div><h4 class=\"title\">Our Availabilty: </h4><ul><li><span class=\"fw-bold\"> Customer Service Team:</span> Available from <span>9:00 AM to 5:00 PM,</span> Monday to Friday. We are ready to address any queries related to your account, job postings, and general inquiries during these hours. </li><li><span class=\"fw-bold\">Recruitment Hub:</span> Provides extended coverage <span>24 hours a day, 6 days a week</span> to ensure you receive timely support for urgent recruitment-related matters. </li></ul></div><div class=\"service-available\"><p>We aim to make your experience with WORKPAGES seamless and hassle-free.<br> If you need further contact details, such as our email or office address, please visit the relevant section on our website. </p></div>", 2)
const _hoisted_33 = { class: "col-lg-6" }
const _hoisted_34 = { class: "contact-form form-wrapper" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-inner mb-25" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Your Name*", -1)
const _hoisted_39 = { class: "input-area" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-inner mb-25" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email*", -1)
const _hoisted_44 = { class: "input-area" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/email-2.svg",
  alt: ""
}, null, -1)
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "form-inner mb-25" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "jobplace" }, "Company Name (Optional)", -1)
const _hoisted_49 = { class: "input-area" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_51 = { class: "col-md-12" }
const _hoisted_52 = { class: "form-inner mb-25" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "jobplace" }, "Subject", -1)
const _hoisted_54 = { class: "input-area" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_56 = { class: "col-md-12" }
const _hoisted_57 = { class: "form-inner mb-40" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Message*", -1)
const _hoisted_59 = { class: "col-md-12" }
const _hoisted_60 = { class: "form-inner" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("b", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_64 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "inner-banner",
      style: _normalizeStyle(_ctx.bgImage)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", {
                style: _normalizeStyle(_ctx.textColor)
              }, "Contact", 4),
              _hoisted_5
            ])
          ])
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", { innerHTML: _ctx.cmsPages }, null, 8, _hoisted_8)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("h5", null, _toDisplayString(_ctx.globalSettings._site_city) + ", " + _toDisplayString(_ctx.globalSettings._site_country), 1),
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _hoisted_18,
                        _createTextVNode(" " + _toDisplayString(_ctx.globalSettings._site_email), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_ctx.globalSettings._site_contact_no), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_20,
                        _createTextVNode(" " + _toDisplayString(_ctx.globalSettings._site_address), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              _createElementVNode("div", null, [
                _hoisted_27,
                _createElementVNode("h6", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("a", _hoisted_30, _toDisplayString(_ctx.globalSettings._site_support_no), 1)
                ])
              ]),
              _hoisted_31
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("form", {
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "name",
                          name: "name",
                          placeholder: "Mr. Jackson Mile",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.formData.name]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          id: "email",
                          name: "email",
                          placeholder: "info@example.com",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.email) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.formData.email]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, [
                        _hoisted_50,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "jobplace",
                          name: "jobplace",
                          placeholder: "Your Company Name",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.company_name) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.formData.company_name]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "jobplace",
                          name: "jobplace",
                          placeholder: "Your Subject",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.company_name) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.formData.company_name]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _withDirectives(_createElementVNode("textarea", {
                        name: "description",
                        id: "description",
                        placeholder: "Your Message...",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.message) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.formData.message]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("button", {
                        class: "primry-btn-2 lg-btn w-unset",
                        type: "submit",
                        disabled: _ctx.loading
                      }, [
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("b", _hoisted_62, [
                              _hoisted_63,
                              _createTextVNode(" Send Message...")
                            ]))
                          : (_openBlock(), _createElementBlock("b", _hoisted_64, "Send Message"))
                      ], 8, _hoisted_61)
                    ])
                  ])
                ])
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ]))
}